import React, { useState, useEffect } from 'react';

import { Button } from 'react-bootstrap5';

import cpaImg from 'images/new_ui/onboarding/example-cpa.png';

import { useContext } from 'components/Members/Onboarding/Context';

import axios from 'axios';

import routes from 'app/routes';

import ExternalLink from 'components/Widgets/ExternalLink';

import { useContext as useUsersContext } from 'components/Users/Context';
import {
  useNavigate,
} from 'react-router-dom';

import FinishGeneral from './FinishGeneral';
import FinishReturnToWork from './FinishReturnToWork';

export default function Finish() {
  const { actions, state } = useContext();

  const [talentAssessment, setTalentAssessment] = useState(null);

  const { state: stateUser } = useUsersContext();

  const navigate = useNavigate();

  const member = stateUser.user?.attributes?.specific;

  useEffect(() => {
    axios
      .get(routes.api.career_pulse_assessment_reports.latest)
      .then((response) => {
        setTalentAssessment(response.data.data);
      });
  }, []);

  const onGoNextClick = () => {
    actions.complete(state.programId, () => {
      if (stateUser.user && stateUser.user.attributes.is_mobile_login) {
        navigate(routes.members.onboarding.webview);
      } else if (member && member.ai_enabled) {
        document.location.href = '/members/home';
      } else {
        document.location.href = '/members/resources';
      }
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">

          <img src={cpaImg} style={{ maxWidth: '100%', objectFit: 'cover' }} alt="Example TA" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0">
            {state.workflow === 'RETURN_TO_WORK_ONBOARDING'
              ? <FinishReturnToWork />
              : <FinishGeneral />}

            <footer className="d-flex justify-content-between mt-5">
              {talentAssessment && stateUser.user && !stateUser.user.attributes.is_mobile_login && (
                <ExternalLink
                  variant="link"
                  href={talentAssessment.attributes.url}
                >
                  Download Report
                </ExternalLink>
              )}

              <Button onClick={onGoNextClick}>
                {member && member.ai_enabled
                  ? 'Assessment Debrief'
                  : 'Start'}
              </Button>
            </footer>

          </div>
        </div>
      </div>
    </div>
  );
}
